var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocationProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "13px",
    viewBox: "0 0 9 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLocationProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.34,8 C78.7159619,8 80.68,9.75796988 80.68,12.2809654 C80.68,13.1946341 80.4209229,14.1719924 80.001875,14.9070181 L76.6212963,20.8379447 C76.5646633,20.9388674 76.4569425,21.0014999 76.34,21.0014999 C76.2230575,21.0014999 76.1153367,20.9388674 76.0587037,20.8379447 L72.678125,14.9070181 C72.2590932,14.1720241 72,13.1946341 72,12.2809654 C72,9.75796988 73.9640381,8 76.34,8 Z M76.34,10.219759 C75.1897328,10.219759 74.2503704,11.1463657 74.2503704,12.2809654 C74.2503704,13.4155794 75.189736,14.3421687 76.34,14.3421687 C77.490264,14.3421687 78.4296296,13.4155794 78.4296296,12.2809654 C78.4296296,11.1463657 77.4902672,10.219759 76.34,10.219759 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-7",
    transform: "translate(-89.000000, -2911.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(17.000000, 2903.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icLocationProfile",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationProfile);
export default __webpack_public_path__ + "static/media/icLocationProfile.38f57c7f7367194ff56615e97c1a72cd.svg";
export { ForwardRef as ReactComponent };